import React, { useMemo, useState } from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { DetailModal } from './DetailModal';
interface LOSubmissionData {
  loName: string;
  dirtyFiles: number;
  missingConditions: number;
}
interface DirtyFileRecord {
  loName: string;
  fileNumber: string;
  borrower: string;
  submittedDate: string;
  missingDocs: string[];
  status: string;
}
interface SubmissionQualityProps {
  selectedLO: string;
}
type ViewMode = 'dirty-files' | 'missing-conditions';
const allSubmissionData: LOSubmissionData[] = [{
  loName: 'Alex Kim',
  dirtyFiles: 8,
  missingConditions: 19
}, {
  loName: 'Priya Patel',
  dirtyFiles: 6,
  missingConditions: 9
}, {
  loName: 'Michael Davis',
  dirtyFiles: 5,
  missingConditions: 6
}, {
  loName: 'Sarah Chen',
  dirtyFiles: 4,
  missingConditions: 5
}, {
  loName: 'Jann Fmt',
  dirtyFiles: 3,
  missingConditions: 4
}, {
  loName: 'Roda Kim',
  dirtyFiles: 2,
  missingConditions: 3
}, {
  loName: 'Chrao Dunon',
  dirtyFiles: 1,
  missingConditions: 2
}];
const allDirtyFileRecords: DirtyFileRecord[] = [{
  loName: 'Alex Kim',
  fileNumber: '#770101',
  borrower: 'John Smith',
  submittedDate: '04/20/2026',
  missingDocs: ['Purchase Agreement', 'W-2 (2025)'],
  status: 'In UW'
}, {
  loName: 'Alex Kim',
  fileNumber: '#770102',
  borrower: 'Amy Zhang',
  submittedDate: '04/18/2026',
  missingDocs: ['Bank Statements (2 mo)', 'Gift Letter'],
  status: 'In UW'
}, {
  loName: 'Alex Kim',
  fileNumber: '#770103',
  borrower: 'Carlos Ruiz',
  submittedDate: '04/22/2026',
  missingDocs: ['Pay Stubs (30 day)', 'VOE'],
  status: 'Suspended'
}, {
  loName: 'Alex Kim',
  fileNumber: '#770104',
  borrower: 'Diana Park',
  submittedDate: '04/19/2026',
  missingDocs: ['Tax Returns (2 yr)'],
  status: 'In UW'
}, {
  loName: 'Alex Kim',
  fileNumber: '#770105',
  borrower: 'Eric Johnson',
  submittedDate: '04/21/2026',
  missingDocs: ['HOI Binder', 'Flood Cert', 'Title Commitment'],
  status: 'Suspended'
}, {
  loName: 'Alex Kim',
  fileNumber: '#770106',
  borrower: 'Fiona Lee',
  submittedDate: '04/17/2026',
  missingDocs: ['Asset Docs', 'Divorce Decree'],
  status: 'In UW'
}, {
  loName: 'Alex Kim',
  fileNumber: '#770107',
  borrower: 'Greg Tanaka',
  submittedDate: '04/23/2026',
  missingDocs: ['Appraisal', 'Survey'],
  status: 'In UW'
}, {
  loName: 'Alex Kim',
  fileNumber: '#770108',
  borrower: 'Helen Moss',
  submittedDate: '04/16/2026',
  missingDocs: ['1099 (2025)', 'P&L Statement', 'Business License'],
  status: 'Suspended'
}, {
  loName: 'Priya Patel',
  fileNumber: '#770201',
  borrower: 'Ian Cooper',
  submittedDate: '04/20/2026',
  missingDocs: ['Purchase Agreement'],
  status: 'In UW'
}, {
  loName: 'Priya Patel',
  fileNumber: '#770202',
  borrower: 'Julia Reyes',
  submittedDate: '04/19/2026',
  missingDocs: ['W-2 (2025)', 'Pay Stubs'],
  status: 'In UW'
}, {
  loName: 'Priya Patel',
  fileNumber: '#770203',
  borrower: 'Kevin Pham',
  submittedDate: '04/21/2026',
  missingDocs: ['Bank Statements'],
  status: 'Suspended'
}, {
  loName: 'Priya Patel',
  fileNumber: '#770204',
  borrower: 'Laura Singh',
  submittedDate: '04/18/2026',
  missingDocs: ['VOE'],
  status: 'In UW'
}, {
  loName: 'Priya Patel',
  fileNumber: '#770205',
  borrower: 'Mark Chen',
  submittedDate: '04/22/2026',
  missingDocs: ['Tax Returns'],
  status: 'In UW'
}, {
  loName: 'Priya Patel',
  fileNumber: '#770206',
  borrower: 'Nina Okafor',
  submittedDate: '04/17/2026',
  missingDocs: ['HOI Binder', 'Title Commitment'],
  status: 'Suspended'
}, {
  loName: 'Michael Davis',
  fileNumber: '#770301',
  borrower: 'Oscar Diaz',
  submittedDate: '04/20/2026',
  missingDocs: ['Purchase Agreement', 'Earnest Money Receipt'],
  status: 'In UW'
}, {
  loName: 'Michael Davis',
  fileNumber: '#770302',
  borrower: 'Paula Grant',
  submittedDate: '04/19/2026',
  missingDocs: ['Pay Stubs (30 day)'],
  status: 'In UW'
}, {
  loName: 'Michael Davis',
  fileNumber: '#770303',
  borrower: 'Quinn Harris',
  submittedDate: '04/21/2026',
  missingDocs: ['Asset Docs'],
  status: 'Suspended'
}, {
  loName: 'Michael Davis',
  fileNumber: '#770304',
  borrower: 'Rachel Kim',
  submittedDate: '04/18/2026',
  missingDocs: ['W-2 (2025)'],
  status: 'In UW'
}, {
  loName: 'Michael Davis',
  fileNumber: '#770305',
  borrower: 'Steve Novak',
  submittedDate: '04/22/2026',
  missingDocs: ['Flood Cert'],
  status: 'In UW'
}, {
  loName: 'Sarah Chen',
  fileNumber: '#770401',
  borrower: 'Tina Morales',
  submittedDate: '04/20/2026',
  missingDocs: ['Gift Letter', 'Bank Statements'],
  status: 'In UW'
}, {
  loName: 'Sarah Chen',
  fileNumber: '#770402',
  borrower: 'Uma Patel',
  submittedDate: '04/19/2026',
  missingDocs: ['Tax Returns (2 yr)'],
  status: 'Suspended'
}, {
  loName: 'Sarah Chen',
  fileNumber: '#770403',
  borrower: 'Victor Wu',
  submittedDate: '04/21/2026',
  missingDocs: ['VOE'],
  status: 'In UW'
}, {
  loName: 'Sarah Chen',
  fileNumber: '#770404',
  borrower: 'Wendy Brooks',
  submittedDate: '04/18/2026',
  missingDocs: ['Purchase Agreement'],
  status: 'In UW'
}, {
  loName: 'Jann Fmt',
  fileNumber: '#770501',
  borrower: 'Xavier Long',
  submittedDate: '04/20/2026',
  missingDocs: ['Pay Stubs', 'W-2'],
  status: 'In UW'
}, {
  loName: 'Jann Fmt',
  fileNumber: '#770502',
  borrower: 'Yolanda Cruz',
  submittedDate: '04/19/2026',
  missingDocs: ['HOI Binder'],
  status: 'In UW'
}, {
  loName: 'Jann Fmt',
  fileNumber: '#770503',
  borrower: 'Zach Turner',
  submittedDate: '04/21/2026',
  missingDocs: ['Title Commitment'],
  status: 'Suspended'
}, {
  loName: 'Roda Kim',
  fileNumber: '#770601',
  borrower: 'Anna Bell',
  submittedDate: '04/20/2026',
  missingDocs: ['Bank Statements', 'Asset Docs'],
  status: 'In UW'
}, {
  loName: 'Roda Kim',
  fileNumber: '#770602',
  borrower: 'Ben Foster',
  submittedDate: '04/19/2026',
  missingDocs: ['Divorce Decree'],
  status: 'Suspended'
}, {
  loName: 'Chrao Dunon',
  fileNumber: '#770701',
  borrower: 'Carla Gomez',
  submittedDate: '04/20/2026',
  missingDocs: ['Purchase Agreement', 'Appraisal'],
  status: 'In UW'
}];
const dirtyFileColumns = [{
  key: 'fileNumber',
  label: 'File #'
}, {
  key: 'borrower',
  label: 'Borrower'
}, {
  key: 'submittedDate',
  label: 'Submitted'
}, {
  key: 'missingDocs',
  label: 'Missing Documents',
  render: (value: string[]) => <div className="flex flex-wrap gap-1" data-id="element-118">
        {value.map((doc, i) => <span key={i} className="px-2 py-0.5 bg-red-50 text-red-700 text-xs rounded border border-red-200" data-id="element-119">
            {doc}
          </span>)}
      </div>
}, {
  key: 'status',
  label: 'Status',
  render: (value: string) => <span className={`px-2 py-1 text-xs font-medium rounded ${value === 'Suspended' ? 'bg-red-100 text-red-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-120">
        {value}
      </span>
}];
const conditionColumns = [{
  key: 'fileNumber',
  label: 'File #'
}, {
  key: 'borrower',
  label: 'Borrower'
}, {
  key: 'submittedDate',
  label: 'Submitted'
}, {
  key: 'conditionCount',
  label: 'Conditions',
  render: (value: number) => <span className="px-2 py-1 bg-orange-100 text-orange-800 text-xs font-bold rounded" data-id="element-121">
        {value} missing
      </span>
}, {
  key: 'missingDocs',
  label: 'Condition Details',
  render: (value: string[]) => <div className="flex flex-wrap gap-1" data-id="element-122">
        {value.map((doc, i) => <span key={i} className="px-2 py-0.5 bg-orange-50 text-orange-700 text-xs rounded border border-orange-200" data-id="element-123">
            {doc}
          </span>)}
      </div>
}];
export function SubmissionQuality({
  selectedLO
}: SubmissionQualityProps) {
  const [viewMode, setViewMode] = useState<ViewMode>('dirty-files');
  const [modalLO, setModalLO] = useState<string | null>(null);
  const filteredData = useMemo(() => {
    const data = selectedLO === 'all' ? allSubmissionData : allSubmissionData.filter(d => d.loName === selectedLO);
    return [...data].sort((a, b) => {
      const valA = viewMode === 'dirty-files' ? a.dirtyFiles : a.missingConditions;
      const valB = viewMode === 'dirty-files' ? b.dirtyFiles : b.missingConditions;
      return valB - valA;
    });
  }, [selectedLO, viewMode]);
  const getValue = (item: LOSubmissionData) => viewMode === 'dirty-files' ? item.dirtyFiles : item.missingConditions;
  const maxCount = filteredData.length > 0 ? Math.max(...filteredData.map(getValue)) : 1;
  const viewLabel = viewMode === 'dirty-files' ? 'Dirty Files' : 'Missing Conditions';
  const modalRecords = useMemo(() => {
    if (!modalLO) return [];
    const records = allDirtyFileRecords.filter(r => r.loName === modalLO);
    if (viewMode === 'missing-conditions') {
      return records.map(r => ({
        ...r,
        conditionCount: r.missingDocs.length
      }));
    }
    return records;
  }, [modalLO, viewMode]);
  const modalSubtitle = modalLO ? viewMode === 'dirty-files' ? `${modalRecords.length} dirty file${modalRecords.length !== 1 ? 's' : ''} submitted with missing documentation` : `${modalRecords.reduce((sum, r) => sum + r.missingDocs.length, 0)} total missing conditions across ${modalRecords.length} file${modalRecords.length !== 1 ? 's' : ''}` : '';
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-124">
      <div className="flex items-center justify-between mb-6" data-id="element-125">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-126">SUBMISSION QUALITY</h2>
        <AlertCircleIcon className="w-6 h-6 text-red-600" data-id="element-127" />
      </div>

      <div className="flex items-center gap-1 p-1 bg-gray-100 rounded-lg w-fit mb-6" data-id="element-128">
        <button onClick={() => setViewMode('dirty-files')} className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${viewMode === 'dirty-files' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-129">
          Dirty Files
        </button>
        <button onClick={() => setViewMode('missing-conditions')} className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${viewMode === 'missing-conditions' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-130">
          Missing Conditions
        </button>
      </div>

      {filteredData.length === 0 ? <div className="py-12 text-center" data-id="element-131">
          <p className="text-sm text-gray-500" data-id="element-132">
            No dirty files for this loan officer.
          </p>
        </div> : <>
          <div className="mb-6" data-id="element-133">
            <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-134">
              {viewLabel} per LO
            </h3>
            <div className="flex items-end gap-3 h-48" data-id="element-135">
              {filteredData.map((item, index) => {
            const value = getValue(item);
            const heightPercent = value / maxCount * 100;
            return <button key={`${item.loName}-${index}`} onClick={() => setModalLO(item.loName)} className="flex-1 flex flex-col items-center gap-2 group cursor-pointer" data-id="element-136">
                    <span className="text-xs font-bold text-gray-700 group-hover:text-blue-600 transition-colors" data-id="element-137">
                      {value}
                    </span>
                    <div className="w-full flex flex-col justify-end h-36" data-id="element-138">
                      <div className={`w-full rounded-t transition-all duration-300 group-hover:brightness-110 ${viewMode === 'dirty-files' ? 'bg-red-500 group-hover:bg-red-400' : 'bg-orange-500 group-hover:bg-orange-400'}`} style={{
                  height: `${Math.max(heightPercent, 4)}%`
                }} data-id="element-139" />
                    </div>
                    <span className="text-xs font-medium text-gray-600 truncate max-w-full text-center leading-tight group-hover:text-blue-600 transition-colors" data-id="element-140">
                      {item.loName.split(' ')[0]}
                      <br data-id="element-141" />
                      <span className="text-gray-400 group-hover:text-blue-400" data-id="element-142">
                        {item.loName.split(' ')[1]}
                      </span>
                    </span>
                  </button>;
          })}
            </div>
          </div>

          <div className="space-y-2" data-id="element-143">
            <h3 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-144">
              {viewLabel} per LO
            </h3>
            {filteredData.map((item, index) => {
          const value = getValue(item);
          return <button key={`${item.loName}-${index}`} onClick={() => setModalLO(item.loName)} className="w-full flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50/30 transition-colors cursor-pointer text-left" data-id="element-145">
                  <span className="text-sm font-medium text-gray-900" data-id="element-146">
                    LO: {item.loName}
                  </span>
                  <div className="flex items-center gap-3" data-id="element-147">
                    <span className={`text-sm font-bold ${viewMode === 'dirty-files' ? 'text-red-600' : 'text-orange-600'}`} data-id="element-148">
                      {value} {viewLabel}
                    </span>
                    {viewMode === 'dirty-files' && <span className="px-2 py-1 bg-red-100 text-red-800 text-xs font-semibold rounded" data-id="element-149">
                        [Dirty]
                      </span>}
                    {viewMode === 'missing-conditions' && <span className="px-2 py-1 bg-orange-100 text-orange-800 text-xs font-semibold rounded" data-id="element-150">
                        [Conditions]
                      </span>}
                  </div>
                </button>;
        })}
          </div>
        </>}

      <DetailModal isOpen={modalLO !== null} onClose={() => setModalLO(null)} title={`${viewLabel} — ${modalLO}`} subtitle={modalSubtitle} columns={viewMode === 'dirty-files' ? dirtyFileColumns : conditionColumns} data={modalRecords} data-id="element-151" />
    </div>;
}